import React from "react";
import { Table, Tag, Progress } from "antd";
import { FiAlertTriangle, FiAlertCircle, FiCheckCircle, FiActivity } from "react-icons/fi";

export default function SmartAssetProfilingTab() {
	const profilingData = [
		{
			id: 1,
			assetName: "SCADA-SERVER-01",
			type: "SCADA",
			riskScore: 85,
			compliance: 65,
			profileMatch: 92,
			vulnerabilities: 3,
			status: "High Risk",
		},
		{
			id: 2,
			assetName: "HMI-WORKSTATION-02",
			type: "HMI",
			riskScore: 72,
			compliance: 78,
			profileMatch: 88,
			vulnerabilities: 2,
			status: "Medium Risk",
		},
		{
			id: 3,
			assetName: "INDUSTRIAL-PLC-03",
			type: "Industrial",
			riskScore: 58,
			compliance: 82,
			profileMatch: 95,
			vulnerabilities: 1,
			status: "Low Risk",
		},
		{
			id: 4,
			assetName: "NETWORK-DEVICE-04",
			type: "Network",
			riskScore: 45,
			compliance: 89,
			profileMatch: 91,
			vulnerabilities: 0,
			status: "Low Risk",
		},
		{
			id: 5,
			assetName: "COMPUTER-WS-06",
			type: "Computer",
			riskScore: 68,
			compliance: 71,
			profileMatch: 84,
			vulnerabilities: 4,
			status: "Medium Risk",
		},
	];

	const getRiskColor = (score) => {
		if (score >= 70) return "red";
		if (score >= 50) return "orange";
		return "green";
	};

	const columns = [
		{
			title: "Asset Name",
			dataIndex: "assetName",
			key: "assetName",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			width: 100,
			render: (type) => (
				<Tag color="blue">
					{type}
				</Tag>
			),
		},
		{
			title: "Risk Score",
			dataIndex: "riskScore",
			key: "riskScore",
			width: 130,
			render: (score) => (
				<div style={{ width: "100%" }}>
					<Progress
						percent={score}
						strokeColor={getRiskColor(score)}
						size="small"
						format={(percent) => (
							<span className="text-white" style={{ fontSize: 12 }}>
								{percent}%
							</span>
						)}
					/>
				</div>
			),
		},
		{
			title: "Compliance %",
			dataIndex: "compliance",
			key: "compliance",
			width: 130,
			render: (score) => (
				<div style={{ width: "100%" }}>
					<Progress
						percent={score}
						strokeColor="#52c41a"
						size="small"
						format={(percent) => (
							<span className="text-white" style={{ fontSize: 12 }}>
								{percent}%
							</span>
						)}
					/>
				</div>
			),
		},
		{
			title: "Profile Match",
			dataIndex: "profileMatch",
			key: "profileMatch",
			width: 130,
			render: (score) => (
				<div style={{ width: "100%" }}>
					<Progress
						percent={score}
						strokeColor="#1890ff"
						size="small"
						format={(percent) => (
							<span className="text-white" style={{ fontSize: 12 }}>
								{percent}%
							</span>
						)}
					/>
				</div>
			),
		},
		{
			title: "Vulnerabilities",
			dataIndex: "vulnerabilities",
			key: "vulnerabilities",
			width: 120,
			render: (count) => (
				<Tag
					color={count === 0 ? "green" : count <= 2 ? "orange" : "red"}
					className="border-0"
					style={{ color: "#fff" }}
				>
					{count}
				</Tag>
			),
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			width: 120,
			render: (status) => {
				const styleMap = {
					"Low Risk": { backgroundColor: "#dcfce7", color: "#166534" },
					"Medium Risk": { backgroundColor: "#fed7aa", color: "#92400e" },
					"High Risk": { backgroundColor: "#fee2e2", color: "#991b1b" },
				};
				return (
					<Tag
						className="border-0"
						style={styleMap[status]}
					>
						{status}
					</Tag>
				);
			},
		},
	];

	return (
		<>
			<div className="mb-3  mt-5">
				<div className="row g-2">
					<div className="col-lg-3 col-md-6 col-sm-12">
						<div className="card h-lg-100">
							<div className="card-body d-flex flex-column py-4 px-6">
								<div className="fw-semibold fs-6 text-gray-500 mb-3">High Risk Assets</div>
								<div className="d-flex justify-content-between align-items-center">
									<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">03</span>
									<FiAlertTriangle className="fs-2hx text-danger" size={32} />
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6 col-sm-12">
						<div className="card h-lg-100">
							<div className="card-body d-flex flex-column py-4 px-6">
								<div className="fw-semibold fs-6 text-gray-500 mb-3">Medium Risk Assets</div>
								<div className="d-flex justify-content-between align-items-center">
									<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">02</span>
									<FiAlertCircle className="fs-2hx text-warning" size={32} />
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6 col-sm-12">
						<div className="card h-lg-100">
							<div className="card-body d-flex flex-column py-4 px-6">
								<div className="fw-semibold fs-6 text-gray-500 mb-3">Avg Compliance</div>
								<div className="d-flex justify-content-between align-items-center">
									<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">77%</span>
									<FiCheckCircle className="fs-2hx text-success" size={32} />
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6 col-sm-12">
						<div className="card h-lg-100">
							<div className="card-body d-flex flex-column py-4 px-6">
								<div className="fw-semibold fs-6 text-gray-500 mb-3">Total Vulnerabilities</div>
								<div className="d-flex justify-content-between align-items-center">
									<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">10</span>
									<FiActivity className="fs-2hx text-info" size={32} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div style={{ marginTop: 16 }}>
				<Table
					columns={columns}
					dataSource={profilingData}
					rowKey="id"
                    className="table antd-override mb-0"
					pagination={{
						pageSize: 10,
                        className: 'mb-0',
						showTotal: (total, range) => (
							<span>
								{range[0]} to {range[1]} of {total} assets
							</span>
						),
					}}
				/>
			</div>
		</>
	);
}
